exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2bM1zjd4Q67y3miWlRKrxm a,._2bM1zjd4Q67y3miWlRKrxm a:hover{color:#000;text-decoration:none}.lpb_UKvuTWe5RrqG2RG4b{display:none}._22uGctTlYDt71D6I_J4Y9T{margin-top:0;margin-bottom:0}._3fSrp53yGfVIZgALeHJcbo{margin-bottom:.75em}@media (min-width:600px){._2bM1zjd4Q67y3miWlRKrxm{grid-template-columns:2fr 3fr;display:grid;grid-column-gap:20px}.lpb_UKvuTWe5RrqG2RG4b{display:inline}}@media (min-width:1050px){._22uGctTlYDt71D6I_J4Y9T{margin-top:.2em}}", ""]);

// exports
exports.locals = {
	"grid": "_2bM1zjd4Q67y3miWlRKrxm",
	"image": "lpb_UKvuTWe5RrqG2RG4b",
	"title": "_22uGctTlYDt71D6I_J4Y9T",
	"date": "_3fSrp53yGfVIZgALeHJcbo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&minimize&importLoaders=1!./~/postcss-loader!./src/components/PostListing/style.module.css
// module id = ./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/components/PostListing/style.module.css
// module chunks = 3